import actions from "../actions";
import * as constants from "../constants";
import * as util from "../lib/common";
import restoreState from "../lib/restoreState";
import storageManager from "../lib/storageManager";

import { RootState } from "@/reducers/types";

const stateUrl = (store) => (next) => (action) => {
  // 最新の状態を得るために最後にhash書き換え処理を行う必要がある
  next(action);

  if (
    action.type === constants.CONSTRUCTION_SAVE ||
    action.type === constants.APP_CALL_API ||
    action.type.indexOf("LOGIN_") === 0 ||
    action.type === constants.NOTIFICATIONS_BEGIN_FETCH_SUMMARY ||
    action.type === constants.NOTIFICATIONS_END_FETCH_SUMMARY
  ) {
    return;
  }

  if (action.type === constants.LOGOUT_SUCCESS) {
    history.replaceState(undefined, undefined, "/");

    return;
  }

  const state: RootState = store.getState();

  if (!state.app.init) {
    return;
  }

  const constructionId = state.construction.constructionId;
  const constructions = state.construction.constructions;
  let menu = state.session.system === "layout" ? state.layoutApp.layoutMenu : state.app.menu;

  if (constructionId === 0 || !state.session.valid || state.session.shouldLogout || !constructions?.length) {
    // 認証エラーのとき、工事情報がまだ取得できてないとき(たぶん認証できてない)はなにもしない
    return;
  }

  const funcLayout = state.construction?.construction?.func_layout;
  const funcProgress = state.construction?.construction?.func_progress;
  if (funcLayout === 0 && funcProgress === 0) {
    store.dispatch({
      type: constants.APP_SHOW_ERROR,
      payload: { errors: null },
    });

    store.dispatch(actions.login.shouldLogout());

    return;
  }

  const urlState = restoreState();
  const initialMenu = urlState?.menu;
  let defaultSystem = "progress";

  if (
    initialMenu === "machine" ||
    initialMenu === "machine_type" ||
    initialMenu === "plot_plan" ||
    initialMenu === "icon_color"
  ) {
    defaultSystem = "layout";
  }

  if (defaultSystem === "layout" && funcLayout === 0 && funcProgress === 1) {
    defaultSystem = "progress";
  } else if (defaultSystem === "progress" && funcLayout === 1 && funcProgress === 0) {
    defaultSystem = "layout";
  }

  if (initialMenu && !util.getMenuByName(initialMenu)) {
    if (defaultSystem === "progress") {
      history.replaceState(undefined, undefined, `#/${constructionId}/home`);
      store.dispatch(actions.app.changeMenu("home"));
      storageManager.setUserItem("system", "progress");

      return;
    }
  }

  if (menu === "dataimport") {
    menu = "import";
  }

  if (!menu) {
    return;
  }

  // メニュー切替のみ履歴に残す
  if (action.type === constants.APP_SWITCH_SYSTEM) {
    const queryString = urlState?.queryString ? `?${urlState.queryString}` : "";
    // APP_SWITCH_SYSTEMの時点ではlayoutApp.layoutMenuがまだ更新されていないため、
    // action.menuを優先して使用する
    const switchMenu = action.menu || menu;
    history.pushState(null, null, `#/${constructionId}/${switchMenu}${queryString}`);
  } else if (action.type === constants.APP_CHANGE_MENU || action.type === constants.SUMMARY_SELECT_CATEGORY_SUMMARY) {
    // 各メニューへの初回アクセス時（localStorageにデータが入っていない状態）
    // の場合は、hashがlocation.hrefが切り替わらないのでhashから組み立てる
    if (urlState.menu !== action.payload) {
      history.pushState(null, null, `#/${constructionId}/${menu}`);
    } else {
      history.pushState(null, null, location.href);
    }
  }
};

export default stateUrl;
